"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DeliveryType = void 0;

var _Address = _interopRequireDefault(require("../Address"));

var _DeliveryStrip = _interopRequireDefault(require("./DeliveryStrip"));

var _DeliveryPlatformShipping = _interopRequireDefault(require("./DeliveryPlatform/DeliveryPlatformShipping"));

var _EventHandler = _interopRequireDefault(require("../../Events/EventHandler"));

var _Exception = require("../../Exceptions/Exception");

var _ExceptionCode = require("../../Exceptions/ExceptionCode");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const DeliveryType = {
  DELIVER_ON_ADDRESS: 1,
  GET_ON_PLACE: 2
};
exports.DeliveryType = DeliveryType;

class Delivery extends _EventHandler.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "address", null);

    _defineProperty(this, "distance", null);

    _defineProperty(this, "type", 2);

    _defineProperty(this, "total", 0);

    _defineProperty(this, "deliveryStrip", null);

    _defineProperty(this, "deliveryPlatformShipping", null);
  }

  static fromObject(obj) {
    let d = new Delivery();
    Object.keys(obj || {}).forEach(key => {
      let value = obj[key];

      switch (key) {
        case 'address':
          d.address = value ? _Address.default.fromObject(value) : null;
          break;

        case 'deliveryStrip':
          d.deliveryStrip = value ? _DeliveryStrip.default.fromObject(value) : null;
          break;

        case 'deliveryPlatformShipping':
          d.deliveryPlatformShipping = value ? _DeliveryPlatformShipping.default.fromObject(value) : null;

        case 'type':
        case 'total':
        case 'distance':
          d[key] = value;
          break;
      }
    });
    return d;
  }

  validate() {
    /*if (!this.deliveryStrip) {
        throw new EasyException(EasyExceptionCode.DELIVERY_STRIP_NOT_DEFINED);
    }*/
    if (this.type == DeliveryType.DELIVER_ON_ADDRESS) {
      if (!this.address) {
        throw new _Exception.Exception(_ExceptionCode.ExceptionCode.DELIVERY_ADDRESS_NOT_DEFINED);
      }

      if (!this.address.geolocation) {
        throw new _Exception.Exception(_ExceptionCode.ExceptionCode.DELIVERY_GEOLOCATION_NOT_DEFINED);
      } //TODO: Verificar se o endereço está dentro das regiões de entrega


      let isOnlineOrigin = this.trigger('delivery/isOnlineOrigin');
      let storeGeolocation = this.trigger('delivery/getStoreGeolocation');
      let deliveryRegions = this.trigger('delivery/getDelivery');
      let cartTotal = this.trigger('delivery/getCartTotal');
      let distance = this.address.geolocation.distanceTo(storeGeolocation);
      let radiusStrip = deliveryRegions.filter(region => region.up_to * 1000 >= distance); //TODO: Buscar a faixa de endereço e comparar com o valor presente em price            

      if (radiusStrip.length == 0) {
        throw new _Exception.Exception(_ExceptionCode.ExceptionCode.DELIVERY_OUT_OF_REGION);
      }

      if (isOnlineOrigin) {
        if (+radiusStrip[0].min_order > cartTotal) {
          throw new _Exception.Exception(_ExceptionCode.ExceptionCode.DELIVERY_MIN_AMOUNT_REGION);
        }
      }

      if (this.total != radiusStrip[0].price) {
        throw new _Exception.Exception(_ExceptionCode.ExceptionCode.DELIVERY_INVALID);
      }
    } else if (this.type != DeliveryType.GET_ON_PLACE) {
      throw new _Exception.Exception(_ExceptionCode.ExceptionCode.DELIVERY_INVALID);
    }
  }

}

exports.default = Delivery;